import { toJS } from 'mobx';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { RefundReasonMessage } from 'src/view/containers/Messages';
import { ORDER_STATUS } from '~/constants/order';
import { CheckoutStore } from '~/mobx/checkoutStore';
import { IMessageModal, messagesStore } from '~/view/containers/Messages';
import getOrderViewPath from '~/view/screens/CheckoutScreen/getOrderViewPath';

interface IProps extends RouteComponentProps {
  data?: IMessageModal;
  checkoutStore?: CheckoutStore;
}

class CheckoutRefund extends React.Component<IProps, {}> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }

  onRefundSubmit = async (reason: string) => {
    const isOrderCompeted = this.checkoutStore.dependencies.order?.order_status_code === ORDER_STATUS.COMPLETED;
    const isCardEmpty = !this.checkoutStore.dependencies.products.length;
    const orderId = this.checkoutStore.dependencies.order ? this.checkoutStore.dependencies.order.id : '';
    let successfully = false;

    this.checkoutStore.addRefundReason(reason);
    if (isCardEmpty && isOrderCompeted) {
      successfully = await this.checkoutStore.changeStatus(orderId, ORDER_STATUS.CANCELED, reason);
    } else {
      successfully = await this.checkoutStore.update(true);
    }

    messagesStore.removeMessage('refund-reason-message');
    if (orderId && successfully) {
      this.props.history.push(getOrderViewPath(this.checkoutStore.parentStore, orderId), toJS(this.checkoutStore.dependencies.order));
    }
  };

  render() {
    if (!this.checkoutStore.dependencies.order?.total) return;
    return (
      <RefundReasonMessage
        price={this.checkoutStore.refundPrice()}
        input={this.checkoutStore.dependencies.refund_reason}
        data={this.props.data}
        onSubmit={this.onRefundSubmit}
      />
    );
  }
}

export default withRouter(CheckoutRefund);
